/*
  Search typo fixer (Shopify removed Search & Discovery synonyms).
  Turns common misspellings into the word used in our product titles, for
  the type-ahead dropdown (/search/suggest) and the results page (/search).
  Add a line to MAP: 'typo or other spelling': 'word in our titles'.
*/
(function () {
  var MAP = {
    // general words
    'hooka': 'hookah', 'huka': 'hookah', 'hukka': 'hookah', 'hokah': 'hookah', 'hookha': 'hookah',
    'flavor': 'flavour', 'flavors': 'flavours',
    'charcol': 'charcoal', 'charcole': 'charcoal', 'charchoal': 'charcoal',
    'phunel': 'phunnel',
    'mouth piece': 'mouthpiece', 'mouthpeice': 'mouthpiece', 'mouth-piece': 'mouthpiece',
    'hmd': 'heat management', 'difuser': 'diffuser', 'diffusor': 'diffuser',
    'aluminum': 'aluminium', 'gray': 'grey', 'color': 'colour',
    'tweezers': 'tong', 'tweezer': 'tong',
    'gen 3': 'gen iii', 'gen3': 'gen iii', 'generation 3': 'gen iii',
    'gen 2': 'gen ii', 'gen2': 'gen ii', 'generation 2': 'gen ii',
    // brands
    'zkag': 'xkah', 'xka': 'xkah', 'exkah': 'xkah', 'x kah': 'xkah', 'xkha': 'xkah',
    'quazar': 'quasar', 'kuasar': 'quasar',
    'wooka': 'wookah', 'wokah': 'wookah', 'wookha': 'wookah',
    'purj fam': 'purjfam', 'purge fam': 'purjfam', 'purj': 'purjfam',
    'aion': 'aeon',
    'stimulation': 'steamulation', 'steamulator': 'steamulation', 'steamolation': 'steamulation', 'steamulaton': 'steamulation',
    'savaco': 'savacco', 'savako': 'savacco', 'savvacco': 'savacco',
    'kalaud': 'kaloud', 'kalod': 'kaloud', 'kaloude': 'kaloud',
    'starbuz': 'starbuzz', 'star buzz': 'starbuzz', 'starbus': 'starbuzz', 'starbuss': 'starbuzz',
    'tangier': 'tangiers', 'tangers': 'tangiers', 'tangeirs': 'tangiers', 'tangiars': 'tangiers',
    'fumary': 'fumari',
    'alfakher': 'al fakher', 'al-fakher': 'al fakher', 'al fakhar': 'al fakher',
    'djinni': 'dschinni', 'dschini': 'dschinni', 'dshinni': 'dschinni', 'jinni': 'dschinni',
    'alpacca': 'alpaca', 'alpaka': 'alpaca',
    'alfa': 'alpha',
    'elbadia': 'el badia', 'el-badia': 'el badia',
    'oblaco': 'oblako', 'oblacko': 'oblako',
    'werkbunt': 'werkbund', 'werk bund': 'werkbund', 'werkbond': 'werkbund',
    'mose': 'moze', 'mozee': 'moze',
    'kollos': 'kolos', 'colos': 'kolos',
    'japana': 'japona', 'japonna': 'japona',
    'a motion': 'amotion',
    'matt pear': 'mattpear', 'mat pear': 'mattpear', 'matpear': 'mattpear',
    'overdoz': 'overdozz', 'over dozz': 'overdozz', 'overdose': 'overdozz', 'overdoze': 'overdozz',
    'kalil mamoon': 'khalil mamoon', 'khalil mamon': 'khalil mamoon', 'khalil maamoon': 'khalil mamoon',
    'mamai': 'mamay',
    'dark side': 'darkside',
    'mechanika': 'mexanika', 'mehanika': 'mexanika',
    'conseptic': 'conceptic', 'conceptik': 'conceptic',
    'maklod': 'maklaud', 'mak laud': 'maklaud',
    'black burn': 'blackburn',
    'embry': 'embery', 'embury': 'embery',
    'hustler': 'hustla', 'husla': 'hustla',
    'odouman': 'oduman',
    'nagrani': 'na grani',
    'appleontop': 'apple on top', 'apple-on-top': 'apple on top',
    'must have': 'musthave',
    'elbomber': 'el bomber',
    'coco loco': 'cocoloco',
    'coco bration': 'cocobration',
    'blackcocos': 'black cocos',
    'nakla': 'nakhla', 'nahkla': 'nakhla',
    'coal catcher': 'coalcatcher',
    'shisha bucks': 'shishabucks',
    '1 nation': 'one nation', 'onenation': 'one nation',
    'hispa cachimba': 'hispacachimba',
    'mig vulcano': 'mig vulcanos',
    'egerman': 'egermann',
    'crazy 3d': 'crazy3d',
    'telemon': 'telamon',
    'true clouds': 'true cloudz', 'truecloudz': 'true cloudz',
    'bonch': 'bonche',
    'shicarver': 'shi carver',
    'chimera': 'himera',
    'octopus': 'octopuz',
    'smokelab': 'smoke lab',
    'alchimist': 'alchemist', 'alkemist': 'alchemist',
    'novasmoke': 'nova smoke'
  };

  var keys = Object.keys(MAP).sort(function (a, b) { return b.length - a.length; });
  var esc = function (s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };
  var RE = new RegExp('(^|[^a-z0-9])(' + keys.map(esc).join('|') + ')(?=$|[^a-z0-9])', 'gi');

  function correct(q) {
    if (!q) return q;
    return q.replace(RE, function (m, pre, word) { return pre + MAP[word.toLowerCase()]; });
  }
  window.sgSearchCorrect = correct;

  // Type-ahead dropdown: correct the words the theme sends to /search/suggest
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url);
        if (url && url.indexOf('/search/suggest') !== -1) {
          var u = new URL(url, window.location.origin);
          var q = u.searchParams.get('q');
          u.searchParams.set('q', correct(q));
          // Ask for 10 of each kind so the theme can put best sellers first
          // (Shopify alone sends 3-4 products, e.g. only bags for "wookah").
          u.searchParams.set('resources[limit]', '10');
          u.searchParams.set('resources[limit_scope]', 'each');
          input = typeof input === 'string' ? u.pathname + u.search : new Request(u.toString(), input);
        }
      } catch (e) {}
      return nativeFetch.call(this, input, init);
    };
  }

  // Results page: search again with the corrected words and say so
  if (window.location.pathname.indexOf('/search') === 0) {
    var p = new URLSearchParams(window.location.search);
    var q = p.get('q');
    var fixed = correct(q);
    if (q && fixed !== q) {
      p.set('q', fixed);
      p.set('sg_from', q);
      p.delete('page');
      window.location.replace(window.location.pathname + '?' + p.toString());
      return;
    }
    var from = p.get('sg_from');
    if (from) {
      document.addEventListener('DOMContentLoaded', function () {
        var title = document.querySelector('.search__header-title');
        if (!title) return;
        var note = document.createElement('p');
        note.className = 'sg-search-corrected';
        note.textContent = 'You searched for “' + from + '” – showing results for “' + q + '”.';
        title.parentNode.insertBefore(note, title.nextSibling);
      });
    }
  }
})();
